import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Layout, Menu, Modal, message, Popover, Button, Form, Input } from "antd";
import userUtil from "@/utils/user";
import "./header.less";
import { API } from "@/http/api";
import http from "@/http";
import HeaderLogo from "@/images/logo-noslogn.png";
import lqeLogo from "@/images/lqeLogo.jpg";
const { Item: MenuItem } = Menu;


class LoginForm extends React.Component {
  state = {
    loading: false,
  };
  resetFields = () => {
    this.props.form.setFieldsValue({
      originalPassword: '',
      newPassword: '',
    });
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        const config = {
          api: API.userEditUserInfo,
          data: {
            newMobile: this.props.mobile,
            newPassword: values.newPassword,
            originalPassword: values.originalPassword,
          },
        }
        http(config).then((res) => {
          if (res.code == 200) {
            this.setState({ loading: false });
            this.props.setVisible(false);
            this.resetFields(); // 调用resetFields方法
            message.success('修改成功');
          } else {
            this.setState({ loading: false });
            this.resetFields(); // 调用resetFields方法
          }
        })
      }
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <div style={{ height: "300px" }}>
          <Form ref={this.formRef} onSubmit={this.handleSubmit} className="form">
            <Form.Item label="手机号码/账号">
              <Input defaultValue={this.props.mobile} disabled />
            </Form.Item>
            <Form.Item label="原始密码" className="code_item">
              {getFieldDecorator("originalPassword", {
                rules: [{ required: true, message: "请输入您的原始密码" },
                  { pattern: /^.{6,16}$/, message: "密码最少6位最多16位" }
                ]
              })(
                <Input.Password
                  autoComplete="off"
                  className="login-input"
                  placeholder="请输入您的原始密码"
                />
              )}
            </Form.Item>
            <Form.Item label="新密码">
              {getFieldDecorator("newPassword", {
                rules: [{ required: true, message: "请输入您的新密码" },
                  { pattern: /^.{6,16}$/, message: "密码最少6位最多16位" }
                ]
              })(
                <Input.Password
                  autoComplete="off"
                  className="code"
                  placeholder="请输入您的新密码"
                />
              )}
            </Form.Item>
            <Button className="reset-btn" type="primary" htmlType="submit" loading={this.state.loading} block>确定</Button>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedLoginForm = Form.create({ name: 'LoginForm' })(LoginForm);
class Header extends Component {
  state = {
    logoutConfirmVisible: false,
    userName: "",
    logoUrl: '',
    identity: 0,
    crmFlag: '',
    visible: false,
    mobile: '',
    organizationName: '',
  };
  setVisible = (visible) => {
    this.setState({ visible });
  };
  displayLogout = () => {
    this.setState({
      logoutConfirmVisible: true,
    });
  };

  logout = () => {
    const config = {
      api: API.userLogout,
      showLoading: true,
    };
    http(config).then((res) => {
      if (res && res.success) {
        this.hideLogout();
        userUtil.logout();
        localStorage.removeItem('userform');
        localStorage.removeItem('identity');
        window.location.href = "/#/login";
      }
    });
  };

  hideLogout = () => {
    this.setState({
      logoutConfirmVisible: false,
    });
  };


  componentDidMount() {
    this.setState({
      identity: localStorage.getItem('identity'),
    });
    // 去查询 用户信息
    this.queryUserInfo();
  }

  componentWillUnmount() {
    clearInterval(this.interval);

  }
  changePage = () => {
    localStorage.setItem('identity', this.state.identity == '0' ? '1' : '0')
    window.location.href = '/';
  }

  queryUserInfo() {
    var _this = this;
    const config = {
      api: API.usergetLoginInfo,
    };
    http(config).then((res) => {
      if (res.success) {
        localStorage.setItem('userform', JSON.stringify(res.result))
        _this.setState({
          crmFlag: res.result.crmFlag,
          userName: res.result.userName,
          mobile: res.result.mobile
        });
      }
    });
  }
  handleCloseModal = () => {
    this.setState({
      visible: false
    })
  }
  changePassword = () => {
    this.setState({
      visible: true
    })
  }

  render() {
    return (
      <Layout.Header className="header">
        <Link to="/app">
          <div className="logo">
            <img src={HeaderLogo} alt="数通十方云商城运营管理后台" />
            <span className="slogn">{this.state.identity == 0 ? '轨迹查询' : '运营中心'}</span>
          </div>
        </Link>
        <div className="actions-menu" style={{ marginLeft: this.state.identity == 0 ? '73%' : '80%' }}>
          {/* {
            this.state.crmFlag == 0 ? "" :
              <span style={{ marginRight: "20px", cursor: "pointer" }} onClick={this.changePage}>{this.state.identity == 0 ? '运营中心' : '轨迹查询'}</span>
          } */}
          <span className="user-logout">
            {/* <span>{this.state.organizationName}</span> */}
            <Popover
              content={<div>
                <p onClick={this.changePassword} style={{ cursor: "pointer" }}>修改密码</p>
                <p onClick={this.displayLogout} style={{ cursor: "pointer" }}>退出登录</p>
              </div>}
              title="">

              <span style={{ marginLeft: "10px" }}>{this.state.userName}</span>
            </Popover>
          </span>

        </div>
        <Modal
          title="修改密码"
          width={400}
          centered={true}
          visible={this.state.visible}
          onCancel={this.handleCloseModal}
          footer={null}
        >
          <div>
            <WrappedLoginForm setVisible={this.setVisible} mobile={this.state.mobile} {...this.props}></WrappedLoginForm>
          </div>
        </Modal>
        <Modal
          visible={this.state.logoutConfirmVisible}
          title="确认退出登录？"
          width={400}
          closable={false}
          maskClosable={false}
          okText="退出"
          onOk={this.logout}
          onCancel={this.hideLogout}
        />
      </Layout.Header>
    );
  }
}

export default Header;
